module.exports = __webpack_public_path__ + "static/media/Desktop-Banner-Activate-ATM-Card.9bac5233.jpg";